import styled from 'styled-components'

export const StyledStatusArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: 90px;
  margin: 30px 0;

  .content {
    color: #43454f;
    font-size: 13px;
    font-weight: 500;
  }
`
